import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import StadiumRounded from '@mui/icons-material/StadiumRounded';

export default function VenueCard({ venue }) {
  return (
    <Paper sx={{ overflow: 'hidden', position: 'relative', bgcolor: 'background.paper' }}>
      {/* Venue image — constrained to right 40%, with a left-fade so it blends into the card */}
      {venue.image && (
        <Box sx={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '40%' }}>
          <Box
            component="img"
            src={venue.image}
            alt={venue.name}
            sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
          />
          <Box sx={{
            position: 'absolute', inset: 0,
            background: theme => `linear-gradient(to right, ${theme.palette.background.paper} 0%, transparent 50%)`,
          }} />
        </Box>
      )}

      {/* Content sits above the image, constrained to the left 60% */}
      <Box sx={{ p: 2, position: 'relative', width: '60%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
          <StadiumRounded sx={{ color: 'text.secondary', fontSize: 18 }} />
          <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Location
          </Typography>
        </Box>
        <Divider sx={{ mb: 1.5, borderColor: 'divider' }} />
        <Typography variant="body1" sx={{ fontWeight: 700 }}>{venue.name}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>{venue.city}</Typography>
      </Box>
    </Paper>
  );
}
